import React, { useContext, useState } from "react";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ThreeCircles } from "react-loader-spinner";
import { authContext } from "../../Context/Authentication";
import { BASE_URL } from "../../Shared/URL.js";

export default function Login() {
  const { setToken } = useContext(authContext);

  const [ErrorMsg, setErrorMsg] = useState(null);
  const [SuccessMsg, setSuccessMsg] = useState(null);
  const [IsLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const user = {
    email: "",
    password: "",
  };

  async function SendDate(values) {
    setIsLoading(true);

    try {
      let { data } = await axios.post(
        `${BASE_URL}/Account/login`,
        values
      );

      if (data.status === 200) {
        setSuccessMsg("مرحبًا بعودتك!");
        localStorage.setItem(
          "__inventory_sys_auth_token_5f9dA72xQp__",
          data.data.token
        );
        setToken(data.data.token);

        setTimeout(() => {
          navigate("/home");
        }, 800);
      }
    } catch (error) {
      const apiMessage =
        error.response?.data?.error ||
        error.response?.data?.message ||
        "حدث خطأ غير متوقع";

      setErrorMsg(apiMessage);
    }

    setIsLoading(false);
  }

  function checkValidate(values) {
    const errors = {};
    setErrorMsg(null);

    if (!values.email.includes("@") || !values.email.includes(".")) {
      errors.email = "صيغة البريد الإلكتروني غير صحيحة";
    }

    if (
      !values.password.match(
        /(?=^.{8,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/
      )
    ) {
      errors.password = "صيغة كلمة المرور غير صحيحة";
    }

    return errors;
  }

  const formikObject = useFormik({
    initialValues: user,
    validate: checkValidate,
    onSubmit: SendDate,
  });

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{
        minHeight: "100vh",
        background: "#f1f5f9",
        paddingTop: "40px",
      }}
    >
      <div
        style={{
          background: "#fff",
          padding: "40px",
          borderRadius: "12px",
          width: "100%",
          maxWidth: "500px",
          boxShadow: "0 4px 12px rgba(37, 99, 235, 0.15)",
        }}
      >
        <h2
          style={{
            color: "#2563eb",
            fontWeight: "700",
            marginBottom: "25px",
            textAlign: "center",
          }}
        >
          تسجيل الدخول
        </h2>

        {SuccessMsg && (
          <div className="alert alert-success text-center">{SuccessMsg}</div>
        )}

        {ErrorMsg && (
          <div className="alert alert-danger text-center">{ErrorMsg}</div>
        )}

        <form onSubmit={formikObject.handleSubmit}>
          {/* Email */}
          <label style={{ fontWeight: "600", color: "#475569" }}>
            البريد الإلكتروني
          </label>
          <input
            type="email"
            name="email"
            className="form-control mb-3 mt-2"
            value={formikObject.values.email}
            onChange={formikObject.handleChange}
            onBlur={formikObject.handleBlur}
            style={{ padding: "12px", fontSize: "16px" }}
          />

          {formikObject.errors.email && formikObject.touched.email && (
            <div className="alert alert-danger py-2">
              {formikObject.errors.email}
            </div>
          )}

          {/* Password */}
          <label style={{ fontWeight: "600", color: "#475569" }}>
            كلمة المرور
          </label>
          <input
            type="password"
            name="password"
            className="form-control mb-3 mt-2"
            value={formikObject.values.password}
            onChange={formikObject.handleChange}
            onBlur={formikObject.handleBlur}
            style={{ padding: "12px", fontSize: "16px" }}
          />

          {formikObject.errors.password && formikObject.touched.password && (
            <div className="alert alert-danger py-2">
              {formikObject.errors.password}
            </div>
          )}

          {/* Button */}
          <button
            type="submit"
            disabled={!(formikObject.dirty && formikObject.isValid)}
            style={{
              width: "100%",
              background: "#2563eb",
              padding: "12px",
              borderRadius: "8px",
              border: "none",
              color: "#fff",
              fontWeight: "600",
              fontSize: "18px",
              marginTop: "10px",
            }}
          >
            {IsLoading ? (
              <ThreeCircles height="50" width="80" color="#fff" />
            ) : (
              "تسجيل الدخول"
            )}
          </button>

          <hr className="my-4" />
        </form>
      </div>
    </div>
  );
}
